<template>
  <div class="topup-log-page">
    <div class="topup-log-total-spent">
      <p style="color: white; font-size: 15px">Total Topup: <span style="font-size: 20px; color: red">{{ totalDonate }}</span></p>
    </div>
    <div class="ticket-search">
      <q-input
        v-model="fields.userName"
        outlined
        rounded
        input-style="font-size:12px"
        color="orange"
        placeholder="Search By UserName"
        hint-color="white"
        dense
        dark
      >
        <template v-slot:append>
          <q-icon name="search" />
        </template>
      </q-input>

      <q-input
        v-model="fields.referrerUserName"
        outlined
        rounded
        input-style="font-size:12px"
        color="orange"
        placeholder="Search By Referrer UserName"
        hint-color="white"
        dense
        dark
      >
        <template v-slot:append>
          <q-icon name="search" />
        </template>
      </q-input>

      <q-input
        v-model="fields.dateFrom"
        outlined
        rounded
        type="date"
        input-style="font-size:12px"
        color="orange"
        placeholder="Filter Date From"
        hint-color="white"
        dense
        dark
      >
        <template v-slot:append>
          <q-icon name="search" />
        </template>
      </q-input>

      <q-input
        v-model="fields.dateTo"
        outlined
        rounded
        type="date"
        input-style="font-size:12px"
        color="orange"
        placeholder="Filter Date To"
        hint-color="white"
        dense
        dark
      >
        <template v-slot:append>
          <q-icon name="search" />
        </template>
      </q-input>

      <q-btn
        color="orange"
        label="Filter"
        style="margin-right: 16px;"
        @click="getTopupLogs"
      />
      <q-btn
        color="red"
        style="margin-right: 16px;"
        label="Clear Filter"
        @click="this.fields={}"
      />
      <q-btn
        v-if="tableData.length && pay"
        color="green"
        label="Pay"
        @click="payCommissionLocal"
      />
    </div>
    
    <div class="topup-log-table">
      <q-table
        bordered
        title="Topup Logs"
        :rows="tableData"
        :columns="columns"
        row-key="ID"
        separator="cell"
        dark
        :loading="loading"
        rows-per-page-options="0"
        wrap-cells
      />
      <div class="q-pa-lg flex flex-center pagination">
        <q-pagination
          v-model="pagination.current"
          :max="pagination.last"
          direction-links
          outline
          color="orange"
          active-design="unelevated"
          active-color="brown"
          active-text-color="orange"
          @update:model-value="getTopupLogs()"
          :max-pages="3"
        />
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { mapActions } from 'vuex'

export default {
  name: 'ShopLogs',
  computed: {
    dateToday () {
      return moment(new Date()).format('DD MMMM YYYY hh:mm:ss A')
    }
  },
  data () {
    return {
      separator: { label: 'Cell', value: 'cell' },
      columns: [
        {
          name: 'Code',
          align: 'center',
          label: 'Code',
          field: 'Code'
        },
        {
          name: 'CodeValue',
          align: 'center',
          label: 'CodeValue',
          field: 'CodeValue'
        },
        {
          name: 'Comment',
          align: 'center',
          label: 'Comment',
          field: 'Comment'
        },
        {
          name: 'UsedBy',
          align: 'center',
          label: 'UsedBy',
          field: 'UserName'
        },
        {
          name: 'DateUsed',
          align: 'center',
          label: 'Date Used',
          field: 'DateUsed'
        },
        {
          name: 'DateGenerated',
          align: 'center',
          label: 'Date Generated',
          field: 'DateGen'
        }
      ],
      tableData: [],
      totalDonate: 0,
      loading: true,
      fields: {
        userName: null,
        referrerUserName: null,
        dateFrom: null,
        dateTo: null
      },
      pagination: {
        current: 1,
        last: 1
      },
      pay: false
    }
  },
  mounted () {
    this.$q.loading.show()
    
    this.getTopupLogs()

    this.$q.loading.hide()
  },
  methods: {
    ...mapActions({
      payCommission: 'user/payCommission',
      topupLogs: 'user/topupLogs'
    }),
    async getTopupLogs () {
      this.tableData = []

      this.totalDonate = 0

      this.loading = true

      await this.recaptchaLoad('topuplogs')

      const parameter = {
        params: {
          page: this.pagination.current,
          userName: this.fields.userName,
          referrerUserName: this.fields.referrerUserName,
          dateFrom: this.fields.dateFrom,
          dateTo: this.fields.dateTo
        }
      }

      if (parameter.params.referrerUserName) {
        this.pay = true
      }

      if (parameter.params.userName) {
        this.pay = false
      }

      await this.topupLogs(parameter)
        .then(response => {
          const logs = response.data.data
          const total = response.data.total
          
          this.tableData = logs.data

          this.totalDonate = total
          
          this.pagination.current = logs.current_page
          this.pagination.last = logs.last_page

          this.loading = false

        })
        .catch(error => {
          this.loading = false

          this.$q.notify({
            position: 'top-right',
            message: error.response.data.message,
            type: 'negative',
          })
        })

        this.recaptchaLoad('topuplogs')
    },
    async payCommissionLocal () {
      await this.recaptchaLoad('payCommission')

      const parameter = {
        referrerUserName: this.fields.referrerUserName,
        dateFrom: this.fields.dateFrom,
        dateTo: this.fields.dateTo
      }

      this.$q.loading.show()
      await this.payCommission(parameter)
        .then(response => {
          this.$q.loading.hide()

          this.$q.notify({
            position: 'top-right',
            message: response.data.message,
            type: 'positive',
          })

          this.getTopupLogs()
        })
        .catch(error => {
          this.$q.loading.hide()

          this.$q.notify({
            position: 'top-right',
            message: error.response.data.message,
            type: 'negative',
          })
        })
    }
  }
}
</script>
<style lang="scss">
.topup-log-page {
  background-color: $background;
  padding: 24px;
  border-radius: 5px;

  .ticket-search {
    margin-bottom: 16px;

    .q-input {
      margin-bottom: 16px;
    }
  }
}
</style>